import { createStyles } from 'antd-style';

export default createStyles(({ token, css, isDarkMode }) => {
  return {
    multiTabWrapper: css`
      position: sticky;
      top: 56px;
      z-index: 10;
      background: ${isDarkMode ? token.colorFillQuaternary : token.colorBgLayout}; // 暗黑模式下稍微提亮背景，减少反差
      padding: 6px 10px 0;
      user-select: none;
      border-radius: 6px 0 0 0;
      // 覆盖 Antd Tabs 样式
      .ant-tabs-card {
        .ant-tabs-nav {
          margin: 0;
          
          &::before {
            border-bottom: none;
          }

          .ant-tabs-tab {
            background: transparent;
            border: none; // 移除边框
            margin-right: 4px;
            border-radius: 8px 8px 0 0; // 更圆润的圆角
            transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            padding: 8px 16px;
            min-width: 100px;
            justify-content: center;

            // 未激活状态文字颜色
            .ant-tabs-tab-btn {
              color: ${token.colorTextSecondary};
              transition: color 0.3s;
            }

            // Hover 效果
            &:hover {
              background: ${token.colorFillQuaternary};
              .ant-tabs-tab-btn {
                color: ${token.colorText};
              }
            }

            // 激活状态
            &-active {
              background: ${token.colorBgContainer} !important;
              // 亮色模式使用阴影，暗黑模式使用边框高亮
              box-shadow: ${isDarkMode ? 'none' : '0 -1px 2px rgba(0,0,0,0.02)'};
              border-top: ${isDarkMode ? `1px solid ${token.colorBorderSecondary}` : 'none'};
              border-left: ${isDarkMode ? `1px solid ${token.colorBorderSecondary}` : 'none'};
              border-right: ${isDarkMode ? `1px solid ${token.colorBorderSecondary}` : 'none'};
              border-bottom: none;
              
              .ant-tabs-tab-btn {
                color: ${token.colorPrimary};
                font-weight: 500;
              }
            }
            
            // 关闭按钮样式优化
            .ant-tabs-tab-remove {
              margin-left: 8px;
              margin-right: -4px;
              color: ${token.colorTextQuaternary};
              font-size: 11px;
              width: 16px;
              height: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              transition: all 0.2s;

              &:hover {
                color: ${token.colorTextSecondary};
                background: ${token.colorFillTertiary};
              }
            }
          }
        }
      }
    `,
    tabOperationBtn: css`
      width: 32px;
      height: 32px;
      margin-left: 4px;
      margin-bottom: 4px; // 对齐 Tab 底部
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 6px;
      color: ${token.colorTextSecondary};
      transition: all 0.2s;

      &:hover {
        background: ${token.colorFillQuaternary};
        color: ${token.colorText};
      }
    `
  };
});
